import _ from "lodash";

/**
 * When saving to a GPX file, check that the number of trackpoints is 
 * null or a positive integer (where null or 0 indicate "unlimited" trackpoints)
 */
export default class TrackPointLimitChecker {
    
    notValid = false
    
    reset() {
        this.notValid = false;
    }

    rules = [
        (v: string) => {

            // (the trackpoint limit will be a number, never an empty string, but it is a string whilst being validated)
            if (null == v || "" == v || _.isNaN(v) || /^[0-9]+$/.test(v)) { // null, empty string, or only digits
                this.notValid = false;
                return true;
            }

            this.notValid = true;
            return 'Max number of trackpoints must be a positive integer'
        }
    ]
}